let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9XBok")).then(() => parcelRequire('fkQj2'));